


import AtomButton from "../atoms/AtomButton.vue"
import AtomImage from "../atoms/AtomImage.vue"
import AtomLogo from "../atoms/AtomLogo.vue"
import MoleculeContentBlock from "../molecules/MoleculeContentBlock.vue";
import Layout from "../layout/Layout.vue";
import LayoutDefaultBlock from "../layout/LayoutDefaultBlock.vue";
import {computed, defineComponent} from "@vue/composition-api";
import {useStore} from "vuex-composition-helpers";

export default defineComponent({
  name: "StartComponent",
  components: {
    AtomButton,
    AtomImage,
    AtomLogo,
    MoleculeContentBlock,
    Layout,
    LayoutDefaultBlock
  },
  setup: () => {
    const store = useStore()
      
    return {
      startViewModel: computed(() => store.getters.startViewModel),
      labels: computed(() => store.getters.labels),
      handleClick: () => store.dispatch('handleClick')
    }
  }
})
